<header [ngClass]="headerFixed ? 'header-fixed' : ''">
    <div class="responsive-header-wrapper">
        <div class="row-header">
            <div class="col-xs-6">
                <div class="logo-title">
                    <h1 class="sr-only">Teleforum</h1>
                    <a [routerLink]="urlWelcomeBoard" (click)="closeSidebar()"   appTooltip="Torna alla home" placement="bottom" [appTooltipEnabled]="true">
                        <img src="img/logo.png" alt="Teleforum logo">
                        <span class="sr-only">Torna alla home di Teleforum</span>
                    </a>
                </div>
            </div>
            <div class="col-xs-6">
                <div class="user-info">
                    <img src="img/user_logged.png" alt="Utente" />
                    <span *ngIf="userdata" class="">{{ userdata.nome + ' ' + userdata.cognome }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- NAV -->

    <nav aria-label="Navigazione principale" style="position: relative;">
        <div class="nav-wrapper">
            <div class="col-xs-1">
                <button class="btn-link" role="button" *ngIf="!showMenu; else closeMenuIcon" tabindex="0" id="menu-hamburger" type="button" (click)="onMenuClick()"
                    [attr.data-toggle]="" aria-expanded="false">
                    <div></div>
                    <div></div>
                    <div></div>
                </button>
                <ng-template #closeMenuIcon>
                    <div class="close-icon">
                        <img src="img/close-white.png" (click)="onMenuClick()" alt="Chiudi menù" />
                    </div>
                </ng-template>
            </div>
            <div class="col-xs-9">
                <ul class="navigation-tabs">
                    <li role="presentation" class="alert_proxademp" (onClick)="onSideMenuEvent()" prossimi-adempimenti></li>

                    <li role="presentation" class="alert_inevase" (onClick)="onSideMenuEvent()" adempimenti-inevasi></li>

                    <li role="presentation" class="alert_attcomp" (onClick)="onSideMenuEvent()" attivita-completare></li>

                    <li [attr.id]="'notificationsComponent'" (onClick)="onSideMenuEvent()" role="presentation" class="alert_notifica" notifications>
                    </li>
                </ul>
            </div>
            <div class="col-xs-2" style="padding-left: 0;">
                <div user role="presentation" [hideInfo]="true" class="loggeduser"></div>
            </div>
        </div>
    </nav>
    <div class="responsive-menu-wrapper" [ngClass]="showMenu ? 'open-menu' : 'close-menu'" #sidemenu>
        <div>
            <nav ctxMenu="" (onMenuClickEvent)="onSideMenuEvent()" [menuSezioni]="menuSezioni">
            </nav>
        </div>
    </div>
</header>